import { apiRequest } from "@/shared/api/client";
import type { MediaCardItem } from "@/shared/ui/MediaCard";

export type DiscoverMedia = MediaCardItem;

export interface DiscoverSource {
  id: string;
  label: string;
  path: string;
}

/** 精选发现源（覆盖常用，不铺满全部后端榜单） */
export const DISCOVER_SOURCES: DiscoverSource[] = [
  { id: "showing", label: "正在热映", path: "/api/v1/recommend/douban_showing" },
  { id: "movie_hot", label: "热门电影", path: "/api/v1/recommend/douban_movie_hot" },
  { id: "tv_hot", label: "热门剧集", path: "/api/v1/recommend/douban_tv_hot" },
  { id: "top250", label: "豆瓣 TOP250", path: "/api/v1/recommend/douban_movie_top250" },
  { id: "trending", label: "TMDB 趋势", path: "/api/v1/recommend/tmdb_trending" },
  { id: "bangumi", label: "Bangumi 放送", path: "/api/v1/recommend/bangumi_calendar" },
];

export function fetchDiscover(
  sourcePath: string,
  page = 1,
  count = 30,
): Promise<DiscoverMedia[]> {
  // 仅允许预置 path，防止拼接开放 URL
  const allowed = DISCOVER_SOURCES.some((s) => s.path === sourcePath);
  if (!allowed) {
    return Promise.reject(new Error("未知的发现源"));
  }
  const sep = sourcePath.includes("?") ? "&" : "?";
  return apiRequest<DiscoverMedia[]>(
    `${sourcePath}${sep}page=${page}&count=${count}`,
  );
}
